import { render, staticRenderFns } from "./UpcomingDeadlines.vue?vue&type=template&id=52b837c8&scoped=true&"
import script from "./UpcomingDeadlines.vue?vue&type=script&lang=js&"
export * from "./UpcomingDeadlines.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingDeadlines.vue?vue&type=style&index=0&id=52b837c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b837c8",
  null
  
)

export default component.exports